<template>
    <!--:disabled='cashDesks.length === 0'-->
    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        class='invoice-form'
        @submit.prevent='CreateNewInvoice(model.invoice)'
    >
        <v-container>
            <InitialLoading :init-loading='initLoading' />
            <v-row>
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ثبت سند مالی جدید</h3>
                </v-col>
            </v-row>
            <v-row v-if='apartmentCashDesks'>
                <v-col cols='12'>
                    مجموعه
                    {{ apartmentCashDesks.title }}
                </v-col>
                <v-col cols='12' md='4'>
                    <v-select
                        label='انتخاب صندوق'
                        dense
                        filled
                        required
                        :rules='rules.invoice.cashDesk'
                        v-model='model.invoice.cashDesk'
                        :items='cashDesks'
                        item-text='title'
                        return-object
                        no-data-text='موردی یافت نشد'
                    />
                </v-col>
            </v-row>
            <v-row v-if='!initLoading'>
                <v-col cols='12' md='2'>
                    <v-select
                        id='type'
                        :rules='rules.invoice.type'
                        :items='invoiceTypes'
                        item-text='title'
                        return-object
                        @change='handleInvoiceCategoriesByInvoiceType($event)'
                        filled
                        dense
                        hide-details='auto'
                        label='نوع سند مالی'
                        :disabled='disableInputs'
                        v-model='model.invoice.type'
                    ></v-select>
                </v-col>
                <v-col cols='12' md='2'>
                    <v-select
                        id='type'
                        :rules='rules.invoice.category'
                        :items='invoiceCategories'
                        item-text='title'
                        return-object
                        filled
                        dense
                        hide-details='auto'
                        label='دسته بندی سند مالی'
                        v-model='model.invoice.category'
                    ></v-select>
                </v-col>
                <v-col cols='12' md='3'>
                    <v-text-field
                        v-model='model.invoice.title'
                        :rules='rules.invoice.title'
                        required
                        filled
                        dense
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>عنوان
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols='12' md='3'>
                    <CustomCurrencyInput
                        v-model='model.invoice.amount'
                        :rules='rules.invoice.amount'
                        type='number'
                        suffix='تومان'
                        required
                        filled
                        persistent-hint
                        dense
                        min='1'
                        @input='removeFirstZero'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>مبلغ
                        </template>
                    </CustomCurrencyInput>
                </v-col>
                <v-col cols='12' md='2'>
                    <v-text-field
                        id='my-custom-input'
                        filled
                        label='تاریخ'
                        v-model='model.invoice.date'
                        append-icon='mdi-calendar'
                        readonly
                        dense
                        hide-details='auto'
                    />
                    <date-picker
                        :rules='rules.invoice.date'
                        v-model='model.invoice.date'
                        format='jYYYY/jMM/jDD'
                        element='my-custom-input'
                    />
                </v-col>
            </v-row>
            <v-row v-if='!initLoading'>
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>طرف دیگر سند مالی</h3>
                </v-col>
                <v-col cols='12'>
                    <v-row style='justify-items: center'>
                        <v-col cols='12' md='3'>
                            <v-select
                                id='type'
                                :items='contactTypes'
                                item-text='title'
                                item-value='key'
                                filled
                                dense
                                hide-details='auto'
                                label='انتخاب از لیست'
                                :disabled='disableInputs'
                                v-model='contactType'
                            />
                        </v-col>
                        <v-col cols='12' md='3'>
                            <search-contact :disabled='!!contactType'
                                            :type='contactType'
                                            :query='{unit_id}'
                                            v-model='model.invoice.contact'
                            />
                        </v-col>
                        <v-col cols='12' md='3'>
                            <div>
                                <div
                                    v-if='model.invoice.contact._id'
                                    class='d-flex align-center'
                                >
                                    <User :user='model.invoice.contact' show-phone no-status>
                                        <v-list>
                                            <v-list-item
                                                @click='deleteUser()'>
                                                <v-list-item-title>حذف</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </User>
                                </div>
                            </div>
                        </v-col>

                    </v-row>
                </v-col>
                <v-col cols='12'>
                    <v-switch
                        class='mt-0 mb-3'
                        v-model='model.invoice.hasInvoiceItems'
                        @change='hasInvoiceItems($event)'
                        label='جزئیات دارد'
                        hide-details
                    />
                    <div
                        v-if='model.invoice.hasInvoiceItems && model.invoice.invoiceItems && model.invoice.invoiceItems.length>0'
                    >
                        <v-row v-for='(item,index) in model.invoice.invoiceItems' justify-sm='center' :key='index'>
                            <v-col cols='12' md='3'>
                                <v-text-field
                                    id='title'
                                    dense
                                    filled
                                    label='عنوان'
                                    v-model='model.invoice.invoiceItems[index].title'
                                    hide-details='auto'
                                />
                            </v-col>
                            <v-col cols='12' md='2'>
                                <v-text-field
                                    id='count'
                                    dense
                                    filled
                                    label='تعداد'
                                    v-model='model.invoice.invoiceItems[index].count'
                                    hide-details='auto'
                                />
                            </v-col>
                            <v-col cols='12' md='3'>
                                <v-text-field
                                    id='amountPer'
                                    dense
                                    filled
                                    label='مبلغ'
                                    v-model='model.invoice.invoiceItems[index].amountPer'
                                    hide-details='auto'
                                    suffix='تومان'
                                    persistent-hint
                                    min='1'
                                    :hint='balanceHint(model.invoice.invoiceItems[index].amountPer)'
                                    @input='changeTotalAmount(index, $event)'
                                />
                            </v-col>
                            <v-col cols='12' md='3'>
                                <v-text-field
                                    id='totalAmount'
                                    dense
                                    filled
                                    label='مبلغ کل'
                                    v-model='model.invoice.invoiceItems[index].totalAmount'
                                    readonly
                                    :hint='balanceHint(model.invoice.invoiceItems[index].totalAmount)'
                                    persistent-hint
                                    hide-details='auto'
                                />
                            </v-col>
                            <v-col cols='12' md='1' class=' text-center'>
                                <div class='d-md-block d-inline-block ml-2'>
                                    <v-btn
                                        v-if='model.invoice.invoiceItems.length> 0'
                                        icon
                                        name='remove'
                                        small
                                        elevation='2'
                                        @click='model.invoice.invoiceItems.splice(index,1)'
                                        color='error'
                                    >
                                        <v-icon dark>mdi-close</v-icon>
                                    </v-btn>
                                </div>
                                <div class='d-md-block d-inline-block ml-2'>
                                    <v-btn
                                        icon
                                        name='add'
                                        small
                                        elevation='2'
                                        @click='model.invoice.invoiceItems.push({title:"",count:1,amountPer:"",totalAmount:""})'
                                        color='primary'
                                    >
                                        <v-icon dark>mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col cols='12'>
                    <v-switch
                        v-if="model.invoice.type && model.invoice.type.key==='COST'"
                        v-model='model.invoice.status'
                        value='PAYED'
                        label='پرداخت شده'
                    ></v-switch>
                    <v-switch
                        v-if="model.invoice.type && model.invoice.type.key ==='INCOME'"
                        v-model='model.invoice.status'
                        value='PAYED'
                        label='دریافت شده'
                    ></v-switch>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                        v-model='model.invoice.description'
                        filled
                        dense
                        label='توضیحات'
                    >
                    </v-text-field>
                </v-col>
                <v-col cols='12'>
                    <ImageUploader
                        :disableUploadPhotoLength='5'
                        label='عکس'
                        target='invoices--'
                        v-model='model.invoice.photos'
                    />
                </v-col>
                <!-- todo 1.1.1: insert details of factor to cost -->
                <!-- todo 1.1.1: cost is for all unit -->
                <!-- todo 1.1.1: if is not for all add units -->
                <!-- todo 1.1.1: divisionType [equal,percent,amount] -->
                <!-- todo 1.1.1: debts save for resident or owner -->

                <!-- :loading='createNewInvoiceLoading'-->
                <v-col cols='12'>
                    <v-btn
                        :disabled='!valid'
                        name='submit'
                        color='primary'
                        type='submit'
                        @click='validate'
                    >ثبت
                    </v-btn>
                    <v-btn
                        outlined
                        class='mr-2'
                        name='cancel'
                        @click='goBack'
                    >انصراف
                    </v-btn>
                </v-col>
                <v-dialog
                    v-model='uploadDialog'
                    persistent
                >
                    <v-card>
                        <v-row
                            class='fill-height ma-0 text-center'
                            align='center'
                            justify='center'
                        >
                            <v-col cols='12'>
                                <p>
                                    در حال بارگذاری فایل
                                </p>
                                <v-progress-circular class='mb-3' indeterminate></v-progress-circular>
                                <br>
                                <v-btn
                                    small
                                    outlined
                                    @click='cancelUploadImg'
                                >
                                    لغو
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>
                <v-dialog
                    v-model='dialog'
                    max-width='290'
                >
                    <div>
                        <v-text-field
                            id='my-custom-input'
                            filled
                            label='تاریخ'
                            v-model='model.invoice.date'
                            prepend-icon='mdi-calendar'
                            readonly
                            dense
                            hide-details='auto'
                        />                        <!--:disabled='cashDesks.length === 0'-->
                        <date-picker
                            :rules='rules.invoice.date'
                            v-model='model.invoice.date'
                            format='jYYYY/jMM/jDD'
                            element='my-custom-input'
                            @close='$router.back()'
                        />
                    </div>
                </v-dialog>
                <v-dialog v-model='errorDialog' max-width='420'>
                    <v-card>
                        <v-card-title class='px-4'>
                            <span>خطا</span>
                            <code class='font-weight-bold mr-auto'>{{ err.statusCode }}</code>
                        </v-card-title>

                        <v-card-text v-if='err.statusCode === 400' class='mb-0 pb-2 px-4'>
                            <div class='mb-3'> خطا در پردازش اطلاعات، در سرور</div>
                            <v-alert
                                text
                                border='left'
                                prominent
                                color='info'
                                class='mx-0 mb-3'
                            >
                                <v-card-text class='py-0'>
                                    <div class='mb-2'>
                                        <v-icon color='info' class='ml-1'>mdi-alert-circle-outline</v-icon>
                                        <span class='font-weight-bold text--primary'>نکات مهم :</span>
                                        <span class='text--primary'>
								کاربر گرامی، لطفا خطای به بوجود آمده را از طریق ارسال تیکت پشتیبانی به بخش فنی اعلام کنید.
							</span>
                                    </div>

                                </v-card-text>
                            </v-alert>
                        </v-card-text>


                        <v-card-actions class='px-4 pb-4'>
                            <v-btn
                                small
                                color='primary'
                                :to="{name:'CreateSupportRequest'}"
                            >
                                <v-icon>mdi-plus</v-icon>
                                ثبت تیکت پشتیبانی
                            </v-btn>
                            <v-spacer />
                            <v-btn
                                outlined
                                small
                                @click='errorDialog=false'
                            >
                                بستن
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';
    import CustomCurrencyInput from '@/components/CustomCurrencyInput';
    import SearchContact from '@/components/SearchContact';
    import balanceHint from '@/plugins/wordifyfa';
    import ImageUploader from '@/components/ImageUploader';
    import User from '@/components/User';
    import InitialLoading from '@/components/initialLoading';

    const cancelTokenSource = axios.CancelToken.source();
    const moment = require('moment-jalaali');

    export default {
        name: 'CreateTurnover',
        components: {
            InitialLoading,
            User,
            ImageUploader,
            CustomCurrencyInput,
            SearchContact
        },
        data: () => ({
            disableInputs: false,

            apartmentCashDesks: null,
            userImageLoadError: false,
            initLoading: true,

            addContactDialog: false,

            dialog: false,
            errorDialog: false,
            err: {
                statusCode: null
            },

            invoiceTypes: [
                {
                    title: 'هزینه',
                    key: 'COST'
                },
                {
                    title: 'درآمد',
                    key: 'INCOME'
                }
            ],
            invoiceCategories: [],

            contactTypes: [
                {
                    title: 'از مخاطبین حقیقی',
                    key: 'user'
                },
                {
                    title: 'از مخاطبین حقوقی',
                    key: 'legalUser'
                },
                {
                    title: 'از لیست ساکنین و مالکین واحد',
                    key: 'unit'
                },
                {
                    title: 'از لیست پرسنل مجموعه',
                    key: 'personnel'
                }
            ],
            searchContactFields: [],
//            fetchCashDesksOfApartmentLoading: false,
            createNewInvoiceLoading: false,

            valid: true,
            modalDate: false,

            photo: null,
            viewPhotoDialog: false,
            uploadDialog: false,
            selectedPhotoForView: null,
            fileUploadLoading: false,

            apartment_id: null,
            unit_id: null,
            cashDesks: [],
            model: {
                invoice: {
                    hasInvoiceItems: false,
                    type: '',
                    category: '',
                    title: '',
                    amount: '',
                    date: moment(new Date()).format('jYYYY/jMM/jDD'),
                    description: '',
                    invoiceItems: null,
                    cashDesk: null,
                    status: '',
                    photos: [],
                    contact: {},
                    clientCallback: null

                }
            },
            urlQueryRef: {},
            contactType: null,
            rules: {
                invoice: {
                    type: [
                        v => !!v || 'عنوان اجباری میباشد'
                    ],
                    cashDesk: [
                        v => !!v || 'انتخاب صندوق اجباری میباشد'
                    ],
                    category: [
                        v => !!v || 'عنوان اجباری میباشد'
                    ],
                    title: [
                        v => !!v || 'عنوان اجباری میباشد'
                    ],
                    amount: [
                        v => !!v || 'مبلغ اجباری میباشد'
                    ],
                    date: [
                        v => !!v || 'تاریخ اجباری میباشد'
                    ]
//                    cashDesk: [
//                        v => !!v || 'انتخاب صندوق اجباری میباشد'
//                    ]

                }

            },

            ref_id: null,
            ref: null,
            cbUrl: null
        }),
        methods: {
            balanceHint(val) {
                if (!val) return null;
                return balanceHint(val) + ' تومان';
            },
            changeTotalAmount(index, $event) {
                this.model.invoice.invoiceItems[index].totalAmount = this.model.invoice.invoiceItems[index].count * $event;
            },
            deleteUser() {
                this.model.invoice.contact = {};
            },
            imageLoadError() {
                this.userImageLoadError = true;
            },
            selectContact(contact) {
                if (this.model.invoice.contact._id) {
                    if (this.model.invoice.contact.index === contact.index) {
                        this.$snackbar.showMessage({ content: 'انتخاب شده است', color: 'warning', timeout: 3000 });
                    } else {
                        this.model.invoice.contact = contact;
                    }
                } else {
                    this.model.invoice.contact = contact;
                }
            },
            handleInvoiceCategoriesByInvoiceType(value) {
                if (value.key === 'COST') {
                    this.invoiceCategories = [
                        {
                            title: 'حقوق پرسنل',
                            key: 'PERSONNEL_SALARIES',
                            type: 'COST'
                        },
                        {
                            title: 'پرداخت نقدی',
                            key: 'CASH_PAYMENT',
                            type: 'COST'
                        },
                        {
                            title: 'هزینه های عملیاتی',
                            key: 'OPERATING_COSTS',
                            type: 'COST'
                        },
                        {
                            title: 'هزینه های غیر عملیاتی',
                            key: 'NON_OPERATING_EXPENSES',
                            type: 'COST'
                        },
                        {
                            title: 'خرید اموال',
                            key: 'PURCHASE_OF_PROPERTY',
                            type: 'COST'
                        },
                        {
                            title: 'دیگر',
                            key: 'OTHER',
                            type: 'COST'
                        }
                    ];
                } else {
                    this.invoiceCategories = [
                        {
                            title: 'کمیسیون نقل و انتقالات',
                            key: 'TRANSFER_COMMISSION',
                            type: 'INCOME'
                        },
                        {
                            title: 'اجاره پارکینگ',
                            key: 'PARKING_LOT_RENTAL',
                            type: 'INCOME'
                        },
                        {
                            title: 'بدهی',
                            key: 'DEBT',
                            type: 'INCOME'
                        },
                        {
                            title: 'جریمه',
                            key: 'PENALTY',
                            type: 'INCOME'
                        },
                        {
                            title: 'دیگر',
                            key: 'OTHER',
                            type: 'INCOME'
                        }
                    ];
                }
            },
            hasInvoiceItems(value) {
                if (value) {
                    this.model.invoice.invoiceItems = [{ title: '', count: 1, amountPer: '', totalAmount: '' }];
                } else {
                    this.model.invoice.invoiceItems = null;
                }
            },
            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page);
            },
            removeFirstZero(number) {
                this.model.invoice.amount = number.replace(/^0+/, '');
            },
            validate() {
                this.$refs.form.validate();
            },
            async fetchApartmentCashDeskData() {
                await axios
                    .get(`/api/apartments/${this.apartment_id}/cashDesks`)
                    .then(res => {
                        this.apartmentCashDesks = res.data.apartmentCashDesks;
                        let invoices = [];
                        if (this.apartmentCashDesks) {
                            this.apartmentCashDesks.cashDesks.forEach(cashDesk => {
                                invoices = [...invoices, ...cashDesk.invoices];
                                this.cashDesks.push(cashDesk);
                            });
                            this.model.invoice.cashDesk = this.apartmentCashDesks.cashDesks[0];
                        }
                        this.invoices = invoices;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            async CreateNewInvoice(p) {
                this.createNewInvoiceLoading = true;
                let contact = { onModel: p.contact.onModel, item: p.contact._id };
                let data = {
                    invoiceFor: 'INVOICE',
                    ...p,
                    type: p.type.key,
                    category: p.category.key,
                    apartment_id: this.apartment_id,
                    unit_id: this.unit_id,
                    pay_at: moment(p.date, 'jYYYY/jMM/jDD').format('YYYY/MM/DD'),
                    contact
                };
                if (contact.item) {
                    await axios
                        .post(`/api/invoices`, data)
                        .then(() => {
                            this.createNewInvoiceLoading = false;
                            this.$snackbar.showMessage({ content: 'ثبت شد', color: 'success', timeout: 3000 });
                            let query = {};
                            if (this.ref && this.ref_id) {
                                query = {
                                    ref: this.ref,
                                    ref_id: this.ref_id,
                                    apartment_id:this.apartment_id
                                };
                            }
                            this.$router.push({
                                name: 'Invoices',
                                query
                            });

                        })
                        .catch(err => {
                            this.createNewInvoiceLoading = false;
                            this.errorDialog = true;
                            console.log(err);
                        });
                } else {
                    this.createNewInvoiceLoading = false;
                }

            },
            uploadFiles() {
                if (this.photo) {
                    const formData = new FormData();
                    formData.append('photo', this.photo);
                    const imgList = ['image/png', 'image/jpeg', 'image/gif'];
                    if (imgList.includes(this.photo.type)) {
                        if (this.photo.size < 20971520) {
                            this.uploadDialog = true;
                            axios
                                .post(
                                    `api/upload/photos/invoices`,
                                    formData,
                                    {
                                        cancelToken: cancelTokenSource.token
                                    }
                                )
                                .then(async (res) => {
                                    this.model.invoice.photos.push(res.data.url);
                                    this.uploadDialog = false;
                                })
                                .catch((err) => {
                                    this.photo = null;
                                    let message = 'تصویر بارگذاری نشد';
                                    this.$snackbar.showMessage({ content: message, color: 'warning' });
                                    this.uploadDialog = false;
                                    console.error(err);
                                });
                        } else {
                            this.photo = null;
                            this.$snackbar.showMessage({
                                content: 'حداکثر حجم فایل ۲۰ مگابایت میباشد',
                                color: 'warning'
                            });
                        }

                    } else {
                        this.photo = null;
                        this.$snackbar.showMessage({
                            content: 'فرمت فایل نامعتبر میباشد \n فرمت های قابل قبول عبارت اند از \n ' +
                                'jpeg, png, gif',
                            color: 'warning'
                        });
                    }
                }
            },
            cancelUploadImg() {
                cancelTokenSource.cancel();
                this.uploadDialog = false;
                this.photo = null;
            },
            deletePhoto(index) {
                this.model.invoice.photos.splice(index, 1);
            },
            viewPhoto(index) {
                this.viewPhotoDialog = true;
                this.selectedPhotoForView = this.model.invoice.photos[index];
            },

            ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.urlQueryRef = this.$route.query;
            this.ref = this.$route.query.ref;
            this.ref_id = this.$route.query.ref_id;

            if (this.ref === 'apartment') {
                this.apartment_id = this.ref_id;
                this.contactType = 'user';
                await this.fetchApartmentCashDeskData();
            }
            if (this.ref === 'unit') {
                this.unit_id = this.ref_id;
                this.apartment_id = this.$route.query.apartment_id;
                this.handleInvoiceCategoriesByInvoiceType(this.model.invoice.type);
                this.model.invoice.title = this.$route.query.title;
                this.model.invoice.type = await this.invoiceTypes.find(item => item.key === this.$route.query.type);
                this.model.invoice.category = await this.invoiceCategories.find(item => item.key === this.$route.query.category);
                this.contactType = 'unit';
                this.disableInputs = true;
                await this.fetchApartmentCashDeskData();
            }

            if (this.$route.query.cbUrl) {
                this.model.invoice.clientCallback = this.$route.query.cbUrl;
            }

            this.initLoading = false;
            let href = window.location.pathname + window.location.search;
            if (this.ref === 'apartment') {
                await this.setBreadCrumbsTemp({
                    key: 'newInvoice',
                    value: {
                        text: `صورت حساب جدید`,
                        href: href
                    }
                });
            }
            if (this.ref === 'unit') {
                await this.setBreadCrumbsTemp({
                    key: 'newInvoice',
                    value: {
                        text: `بدهی جدید`,
                        href: href
                    }
                });
            }
        },
        async updated() {
            if (this.ref === 'apartment') {
                await this.showBreadCrumbs(['home', 'apartmentDetail', 'invoices', 'newInvoice']);
            }
            if (this.ref === 'unit') {
                await this.showBreadCrumbs(['home', 'apartmentDetail', 'unitList', 'unitDetail', 'newInvoice']);
            }

        },
        computed: {
            ...mapState({
                public_url: state => state.public_url,
                user: state => state.user
            })
        }
    };
</script>
<style lang='scss' scoped>
    .invoice-form {
        :deep().v-btn:not(.v-btn--round).v-size--x-large {
            min-width: 52px !important;
        }

        :deep().image-uploader {
            display: grid;
            grid-gap: 16px;
            grid-template-columns: repeat(3, 1fr);
            justify-items: center;
            align-items: center;

            @media screen and (min-width: 960px) {
                grid-template-columns: repeat(5, 1fr);
            }

            .image-container {
                position: relative;

                .delete-btn {
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                .see-btn {
                    position: absolute;
                    top: 0;
                    right: 0;
                }

                .select-for-cover {
                    position: absolute;
                    bottom: 0;
                }
            }

            .upload-photo-loader {
                width: 86px;
                height: 86px;
                display: flex;
                justify-items: center;
                align-items: center;

                > div {
                    margin: auto;
                }
            }

            .v-image {
                border-radius: 2.5px;

                .v-responsive__sizer {
                    padding: 0 !important;
                }
            }

            .v-text-field {
                margin: 0;
                padding-top: 0;

                .v-input__prepend-outer {
                    margin: 0;

                    .v-input__icon {
                        width: 86px;
                        height: 86px;

                        .v-icon {
                            border: 1px dashed;
                            border-radius: 2.5px;
                            padding: 19.5px;
                            font-size: 45px;

                            &::after {
                                transform: none;
                                border-radius: 2.5px;
                            }
                        }

                    }
                }
            }
        }
    }
</style>